import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiDeleteWithToken,
	ApiPatchWithToken,
	ApiPostWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'
import {
	conventionApi, conventionApiBy,
	searchsKojinApiBy, searchsSisetuApiBy
} from 'interface/endpoints'
import {
  ConventionResult, ConventionResultList,
	ConventionsSpeakerWithConventionNameResultList,
	ConventionFormData
} from './types'

export * from './types'

export const useListConvention = (
	rareDiseaseId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<ConventionResultList>(
        apiAccess,
        conventionApi('/list', { rareDiseaseId }),
        cancelToken
      )
    },
		[rareDiseaseId]
	)
)

export const useGetConvention = (
	conventionId: number | null | undefined,
	searchId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!conventionId) return null
      return ApiGetWithToken<ConventionResult>(
        apiAccess,
        conventionApiBy(conventionId, undefined, { searchId }),
        cancelToken
      )
    },
		[conventionId, searchId]
	)
)

export const usePostConvention = (
  callback?: {
    onPosted?: (result: ConventionResult) => void
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<ConventionFormData, ConventionResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        conventionApi(),
				form,
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditConvention = (
	conventionId: number,
  callback?: {
    onEditted?: (result: ConventionResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<ConventionFormData, ConventionResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        conventionApiBy(conventionId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[conventionId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useDeleteConvention = (
  callback?: {
    onDeleted?: (conventionId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, conventionId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        conventionApiBy(conventionId),
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useListConventionByKojin = (
	searchId: number | undefined | null,
	kojinCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!searchId || !kojinCode) return null
      return ApiGetWithToken<ConventionsSpeakerWithConventionNameResultList>(
        apiAccess,
        searchsKojinApiBy(searchId, kojinCode, '/convention'),
        cancelToken
      )
    },
		[searchId, kojinCode]
	)
)

export const useListConventionBySisetu = (
	searchId: number | undefined | null,
	sisetuCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!searchId || !sisetuCode) return null
      return ApiGetWithToken<ConventionsSpeakerWithConventionNameResultList>(
        apiAccess,
        searchsSisetuApiBy(searchId, sisetuCode, '/convention'),
        cancelToken
      )
    },
		[searchId, sisetuCode]
	)
)
